import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AakashgangaHeader from "../../components/global/HeaderComponent";
import AakashgangaFooter from "../../components/global/FooterComponent";
import arrowLeft from "../../assets/img/icons/arrow_left.svg";
import { blogArticles } from "../GyanKosh/data";
import { blogContents } from "../GyanKosh/blogContents";
import "../GyanKosh/gyankosh.scss";
import "./GyanKoshDetail.scss";

const GyanKoshDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const foundArticle = blogArticles.find((item) => item.slug === slug);
    if (foundArticle) {
      setArticle(foundArticle);
    }
  }, [slug]);

  const handleRedirect = (e, path) => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  if (!article) {
    return (
      <div className="tagbody">
        <AakashgangaHeader />
        <div className="resourceSection innerPages" style={{ background: "#ffffff", padding: "100px 0", textAlign: "center" }}>
          <h2>Blog not found</h2>
          <a onClick={(e) => handleRedirect(e, '/GyanKosh')} style={{ cursor: "pointer", color: "#00a99d" }}>
            Return to Gyan Kosh
          </a>
        </div>
        <AakashgangaFooter />
      </div>
    );
  }

  // Generate recent posts (excluding current if needed, or just top 5)
  const recentPosts = blogArticles.slice(0, 5);

  return (
    <div className="tagbody blog-detail-page">
      <AakashgangaHeader />
      <div className="resourceSection innerPages" style={{ background: "#ffffff", backgroundImage: "none" }}>
        
        {/* Sub Nav Bar similar to Gyan Kosh */}
        <div className="containWrap gyankosh-container" style={{ paddingBottom: "0" }}>
          <div className="sub-nav-bar">
            <a onClick={(e) => handleRedirect(e, '/GyanKosh')} className="sub-nav-item" style={{ cursor: "pointer" }}>GYAN KOSH</a>
            <a href="/all-research-articles" target="_blank" rel="noopener noreferrer" className="sub-nav-item">ARTICLES</a>
            <a href="/presentations" target="_blank" rel="noopener noreferrer" className="sub-nav-item">QUICK LEARNS</a>
            <a href="/browse" target="_blank" rel="noopener noreferrer" className="sub-nav-item">VIDEOS</a>
            <a href="/playlist" target="_blank" rel="noopener noreferrer" className="sub-nav-item">PLAYLISTS</a>
          </div>
        </div>

        {/* 2-Column Blog Layout */}
        <div className="blog-layout-container">
          
          {/* Main Content Area */}
          <div className="blog-main-content">
            
            <div className="blog-main-header">
              <h1>{article.title}</h1>
              <p>{article.date} <span>Vikramshila Education</span></p>
            </div>

            <div className="blog-content-body">
              {blogContents[slug] ? (
                <div dangerouslySetInnerHTML={{ __html: blogContents[slug] }} />
              ) : (
                <p>Content is not available for this article.</p>
              )}
            </div>

            {/* Leave a Reply Form */}
            <div className="leave-reply-section">
              <h3>Leave a Reply</h3>
              <p>Your email address will not be published. Required fields are marked <span className="required-star">*</span></p>
              
              <form className="reply-form" onSubmit={(e) => {
                e.preventDefault();
                alert("Your comment has been submitted and is awaiting moderation.");
                e.target.reset();
              }}>
                <div className="form-group">
                  <label>Comment <span className="required-star">*</span></label>
                  <textarea required></textarea>
                </div>
                <div className="form-group">
                  <label>Name <span className="required-star">*</span></label>
                  <input type="text" required />
                </div>
                <div className="form-group">
                  <label>Email <span className="required-star">*</span></label>
                  <input type="email" required />
                </div>
                <div className="form-group">
                  <label>Website</label>
                  <input type="url" />
                </div>
                <div className="form-group checkbox-group">
                  <input type="checkbox" id="save-info" />
                  <label htmlFor="save-info" style={{marginBottom: 0, fontWeight: "normal"}}>
                    Save my name, email, and website in this browser for the next time I comment.
                  </label>
                </div>
                <button type="submit">Post Comment</button>
              </form>
            </div>

          </div>

          {/* Sidebar */}
          <div className="blog-sidebar">
            
            <div className="sidebar-widget">
              <h4>Search</h4>
              <form className="sidebar-search" onSubmit={(e) => e.preventDefault()}>
                <input type="text" placeholder="" />
                <button type="submit">Search</button>
              </form>
            </div>

            <div className="sidebar-widget">
              <h4>Recent Posts</h4>
              <div className="sidebar-recent-posts">
                {recentPosts.map((post) => (
                  <a 
                    key={post.id} 
                    onClick={(e) => handleRedirect(e, `/GyanKosh/${post.slug}`)} 
                    className="recent-post-item"
                    style={{ cursor: "pointer" }}
                  >
                    {post.title}
                  </a>
                ))}
              </div>
            </div>

            <div className="sidebar-widget">
              <h4>Recent Comments</h4>
              <div className="sidebar-comments">
                No comments to show.
              </div>
            </div>

            <div className="sidebar-widget">
              <h4>Archives</h4>
              <div className="sidebar-archives">
                <ul>
                  <li><a href="#">May 2024</a></li>
                  <li><a href="#">February 2023</a></li>
                  <li><a href="#">January 2023</a></li>
                </ul>
              </div>
            </div>

          </div>

        </div>

      </div>
      <AakashgangaFooter />
    </div>
  );
};

export default GyanKoshDetail;
